import React from 'react';
import { Link } from 'react-router-dom';

export default function VendorCTA() {
  return (
    <section className="vendor-cta">
      <div className="vendor-cta-content">
        <h2>¿Eres proveedor de servicios para XV años?</h2>
        <p>
          Anúnciate en MisXV.com.mx y llega a miles de familias que están planeando la fiesta de
          XV años en tu ciudad. Recibe cotizaciones directas, muestra tu galería y gestiona tus
          reseñas desde un solo lugar.
        </p>
        <Link to="/anunciate" className="btn btn-gold">Anúnciate con nosotros</Link>
      </div>
    </section>
  );
}
